module.exports = __webpack_public_path__ + "static/media/star-vi.5dcbb8ce.png";